import { useMemo, useEffect } from 'react';
import moment from 'moment';
import { LangEnum } from '@enums';

export const useAppLocale = (lang: LangEnum): string => {
  const currentLocale = useMemo<string>(() => {
    if (lang === LangEnum.ENG) {
      return 'en-gb';
    }

    return 'ru';
  }, [lang]);

  useEffect(() => {
    moment.locale(currentLocale);
  }, [currentLocale]);

  return currentLocale;
};
